/// <reference types="vite/client" />
import { HeadContent, Scripts, createRootRoute } from "@tanstack/react-router";
import type { ReactNode } from "react";
import appCss from "../styles/app.css?url";

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { charSet: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { title: "notify — native browser push in 60 seconds" },
      {
        name: "description",
        content:
          "Hosted browser push notifications for developers. One script tag, one function, native notifications. No Firebase, no VAPID keys, no service worker boilerplate.",
      },
      // Social share card (Open Graph + Twitter)
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://getnotify.dev" },
      { property: "og:site_name", content: "notify" },
      { property: "og:title", content: "notify — native browser push in 60 seconds" },
      {
        property: "og:description",
        content:
          "One script tag, one function, native browser notifications. No Firebase, no VAPID keys, no service worker boilerplate.",
      },
      { property: "og:image", content: "https://getnotify.dev/og.png" },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:image:alt", content: "notify — push in 60s." },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "notify — native browser push in 60 seconds" },
      {
        name: "twitter:description",
        content:
          "One script tag, one function, native browser notifications. No Firebase, no VAPID keys.",
      },
      { name: "twitter:image", content: "https://getnotify.dev/og.png" },
    ],
    links: [
      { rel: "stylesheet", href: appCss },
      { rel: "icon", href: "/favicon.svg", type: "image/svg+xml" },
      // Fonts are self-hosted and declared in app.css — no third-party hop, no
      // extra round trips. Deliberately NOT preloaded: with font-display:swap
      // nothing waits on them, so preloading 66KB at High priority only steals
      // bandwidth from the CSS/JS. Measured LCP 3.8s without vs 4.1s with.
    ],
  }),
  shellComponent: RootDocument,
});

function RootDocument({ children }: { children: ReactNode }) {
  return (
    <html lang="en">
      <head>
        <HeadContent />
        {/* DataFast analytics — official script tag, auto-tracks pageviews (incl. SPA navigations). */}
        <script
          defer
          src="https://datafa.st/js/script.js"
          data-website-id="dfid_el5qQ6p5zlbuKpHvmWItP"
          data-domain="getnotify.dev"
        />
      </head>
      <body>
        {children}
        <Scripts />
      </body>
    </html>
  );
}
